import * as React from 'react';
import { useSearch } from 'src/hooks';
import { ALL_TABLE_ROWS_VALUE } from './constant';

export const useTableCheckbox = (value: string) => {
  const [searchParams, setSearchParams] = useSearch();

  const isChecked =
    Boolean(searchParams?.tableRows?.includes?.(value)) ||
    Boolean(searchParams?.tableRows?.includes?.(ALL_TABLE_ROWS_VALUE));

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    e.stopPropagation();

    const { checked } = e.target;

    setSearchParams((prevSearchParams) => {
      const prevTableRows = prevSearchParams?.tableRows || [];

      /**
       * let all value take precedence i.e when selected,
       * clear every other values in the array and replace
       * with ALL_TABLE_ROWS_VALUE so when user unchecks it,
       * every other table row values are deselected too
       */
      if (value === ALL_TABLE_ROWS_VALUE) {
        return {
          ...(prevSearchParams || {}),

          tableRows: checked ? [value] : [],
        };
      }

      return {
        ...(prevSearchParams || {}),
        tableRows: checked ? [...prevTableRows, value] : prevTableRows.filter((item) => item !== value),
      };
    });
  };

  return {
    isChecked,
    handleChange,
  };
};
